<script setup>
/**
 * FormControlPagesUrl
 * Lightweight alias wrapper around the core URL slug generation engine.
 * Forwards structural configuration metrics and dynamic text mutation bubbles
 * natively down to the underlying atomic form routing element.
 */
import FormControlUrlSlug from './FormControlUrlSlug.vue'

defineProps({
    // Standard Orchestrator Props passed through natively
    formId: {
        type: String,
        required: true
    },
    field: {
        type: Object,
        required: true
    },
    currentData: {
        type: Object,
        required: true
    },
    value: {
        type: [String, Number],
        default: null
    }
})
</script>

<template>
    <FormControlUrlSlug v-bind="$props"/>
</template>